module.exports = __webpack_public_path__ + "img/2nd.4e07436.png";